import { DateHelper } from "./DateHelper";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import jwt_decode from "jwt-decode";

const MySwal = withReactContent(Swal)
let dateHelper = new DateHelper();
export default function () {
    if (sessionStorage.jwtToken && sessionStorage.preferences) {
        try {
            const currentTime = Date.now() / 1000;
            const decoded = jwt_decode(sessionStorage.jwtToken);
            let duration = dateHelper.unix(decoded.exp).diff(dateHelper.unix(currentTime), "seconds");
            setTimeout(() => {
                // alert("You have been logged out due to inactivity")
                TimeOut()
                sessionStorage.removeItem("jwtToken");
                sessionStorage.removeItem("preferences");
            }, duration * 1000)

        }
        catch {
            return;
        }
    }
}
function TimeOut() {
    return MySwal.fire({
        text: "Your session has ended due to inactivity. Please sign in again.",
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Okay',
    }).then(() => {
        window.location.href = "/";
    })
}
